export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/moneyIcon.e9c01033.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};